import dayjs from "dayjs";

export function SaveCalendar(this: any) {
  return {
    calendarId: this.calendarId ?? -1,
    calendarName: this.calendarName,
    nonProductionDays: this.nonProductionDays.map((nonProdDay:any) => {
      return {...nonProdDay, date: dayjs(nonProdDay?.date).utcOffset(0, true)}
    }),
    smsSchedule: this.smsAllowedTime?.filter((day: any) => day.isEnable == true).map((day:any) => {
      return {...day, timeSlots: day.timeSlots.map((slot: any) => {
        return {...slot, startTime: dayjs(slot.startTime).utcOffset(0, true), endTime: dayjs(slot.endTime).utcOffset(0, true)}
      })}
    })
  };
}
